// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The physical (spatial) possibility for a passenger to change from one public transport vehicle to another to continue the `Trip`, determined by two `ScheduledStopPoint's`. Different times may be necessary to cover the link between these points, depending on the kind of passenger.
 * @export
 * @interface Connection
 */
export interface Connection {
    /**
     * Minimal transfer [duration](https://www.w3.org/TR/xmlschema11-2/#duration) for a mobility impaired traveller to make transfer. Relates to `includeAccessibility` other than `ALL`. See `mobilityRestrictedTravellerTransferRule` for the rules applied to determine the time needed.
     * @type {string}
     * @memberof Connection
     */
    mobilityRestrictedTravellerDuration?: string;
    /**
     * Hint whether the vehicle transfer is critical for handicaped people, related to `mobilityRestrictedTravellerDuration`.
     * @type {boolean}
     * @memberof Connection
     */
    mobilityRestrictedTravellerTransferCritical?: boolean;
    /**
     * Hint for handicaped experts (such as AMO) about which duration rule was applied to determine minimal transfer time.
     * @type {string}
     * @memberof Connection
     */
    mobilityRestrictedTravellerTransferRule?: string;
}

/**
 * Check if a given object implements the Connection interface.
 */
export function instanceOfConnection(value: object): value is Connection {
    return true;
}

export function ConnectionFromJSON(json: any): Connection {
    return ConnectionFromJSONTyped(json, false);
}

export function ConnectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Connection {
    if (json == null) {
        return json;
    }
    return {
        
        'mobilityRestrictedTravellerDuration': json['mobilityRestrictedTravellerDuration'] == null ? undefined : json['mobilityRestrictedTravellerDuration'],
        'mobilityRestrictedTravellerTransferCritical': json['mobilityRestrictedTravellerTransferCritical'] == null ? undefined : json['mobilityRestrictedTravellerTransferCritical'],
        'mobilityRestrictedTravellerTransferRule': json['mobilityRestrictedTravellerTransferRule'] == null ? undefined : json['mobilityRestrictedTravellerTransferRule'],
    };
}

  export function ConnectionToJSON(json: any): Connection {
      return ConnectionToJSONTyped(json, false);
  }

  export function ConnectionToJSONTyped(value?: Connection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mobilityRestrictedTravellerDuration': value['mobilityRestrictedTravellerDuration'],
        'mobilityRestrictedTravellerTransferCritical': value['mobilityRestrictedTravellerTransferCritical'],
        'mobilityRestrictedTravellerTransferRule': value['mobilityRestrictedTravellerTransferRule'],
    };
}

